"use client";

import { clsx } from "@trydig/ui";
import { useEffect, useState } from "react";
import { Container } from "@/components/ui/Container";

export const GridOverlay = () => {
	const [show, setShow] = useState(false);

	useEffect(() => {
		const onKeyDown = (e: KeyboardEvent) => {
			if (!e.shiftKey || e.metaKey || e.ctrlKey || e.altKey) return;
			if (e.key !== "G" && e.key !== "g") return;
			const target = e.target as HTMLElement | null;
			if (
				target &&
				(target.tagName === "INPUT" || target.tagName === "TEXTAREA" || target.isContentEditable)
			) {
				return;
			}
			e.preventDefault();
			setShow((v) => !v);
		};
		window.addEventListener("keydown", onKeyDown);
		return () => window.removeEventListener("keydown", onKeyDown);
	}, []);

	if (!show) return null;

	return (
		<div aria-hidden className="pointer-events-none fixed inset-0 z-[9999]" data-grid-overlay>
			<Container className="h-full">
				<div className="grid grid-cols-6 lg:grid-cols-12 gap-(--layout-gap) h-full">
					{Array.from({ length: 12 }).map((_, i) => (
						<div
							// biome-ignore lint/suspicious/noArrayIndexKey: static grid overlay, indices are stable
							key={i}
							className={clsx(
								"h-full bg-fuchsia-400/15 border-x border-fuchsia-400/40",
								// Columns 7–12 only render at lg+ (mobile/tablet are a 6-col grid).
								i >= 6 && "hidden lg:block",
							)}
						/>
					))}
				</div>
			</Container>
		</div>
	);
};
